import getAPI from './getAPI.js'

export default async function getAdobeSignTemplateFields(templateId) {
    const data = await getAPI(`admin/adobesign/templates/${templateId}/fields`);
    return data;
}
